import React from 'react';
import styled from 'styled-components';
import { media, colors, fonts } from '../../css';

// const spreadSrc = ({ src, ...rest }) => <div {...rest} />;

const spreadSrc = (props) => {
  const { src, className, ...rest } = props;
  return <div {...rest} src={src} className={className} />;
};

export const StyledAvatarWrapper = styled(spreadSrc)`
  border-radius: 50%;
  overflow: hidden;
  width: 63px;
  height: 63px;

  ${({ src }) =>
    !src
      ? `display: flex;
        justify-content: center;
        background-color: ${colors.colorWhite};
        border: 1px solid ${colors.colorBlue};`
      : ``};

  ${media.greaterThan('lg')`
    width: 80px;
    height: 80px;
  `};
`;

export const StyledInitials = styled.p`
  align-self: center;
  font-family: ${fonts.fontBold};
  color: ${colors.colorBlue};
  font-size: 1.4em;
  text-transform: uppercase;

  ${media.greaterThan('lg')`
    font-size: 1.6em;
  `};
`;
